import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  private loaderSubject: any = new Subject<LoaderState>();
  public loaderState: any = this.loaderSubject.asObservable();
  constructor() { }
  show() {
    this.loaderSubject.next(<LoaderState>{ show: true });
   }
   hide() {
    this.loaderSubject.next(<LoaderState>{ show: false });
   }
}
export interface LoaderState {
  show: boolean;
}
